import React from 'react';
import { HighchartsReactRefObject } from 'highcharts-react-official';

import { ChartContent } from '../../Chart';

const PackedBubbleView = ({
  chartRef,
  options,
  isNoData,
  useSmallNoDataMessage,
}: {
  chartRef: React.MutableRefObject<HighchartsReactRefObject | null>;
  options: Highcharts.Options;
  isNoData: boolean;
  useSmallNoDataMessage: boolean;
}) => {
  return (
    <ChartContent
      chartRef={chartRef}
      options={options}
      noDataToDisplay={isNoData}
      useSmallNoDataMessage={useSmallNoDataMessage}
    />
  );
};

export default PackedBubbleView;
